var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.titles, function (item, i) {
        return [
          item.num
            ? _c(
                "title-block",
                { key: i, attrs: { id: "bm" + item.label } },
                [
                  _c("template", { slot: "title" }, [
                    _vm._v(_vm._s(item.label)),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-10" },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: item.loading,
                              expression: "item.loading",
                            },
                          ],
                          attrs: {
                            data: _vm.tableDatas(item.moduleId),
                            "header-cell-style": {
                              background: "#fafafa",
                              color: "#333",
                            },
                            "tooltip-effect": "light",
                          },
                        },
                        [
                          _vm._l(
                            _vm.tableFields(item.moduleId),
                            function (item1, j) {
                              return [
                                item.field !== "link"
                                  ? _c("el-table-column", {
                                      key: j,
                                      attrs: {
                                        "min-width": item.minWidth + "px",
                                        fixed: item.fixed || false,
                                        prop: item.field,
                                        label: item.fieldName,
                                        align: "center",
                                        "show-overflow-tooltip": "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                [
                                                  "bidHeadLine",
                                                  "headLine",
                                                ].includes(item1.field)
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "textOverflow",
                                                        staticStyle: {
                                                          width: "100%",
                                                          color: "#409eff",
                                                        },
                                                        attrs: {
                                                          rel: "noopener noreferrer",
                                                          underline: false,
                                                          type: "primary",
                                                          href: _vm.columnValueOth(
                                                            item.moduleId,
                                                            j
                                                          ),
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.columnValue(
                                                              scope.row[j],
                                                              item.moduleId
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                ["website"].includes(
                                                  item1.field
                                                )
                                                  ? _c(
                                                      "a",
                                                      {
                                                        staticClass:
                                                          "textOverflow",
                                                        staticStyle: {
                                                          width: "100%",
                                                          color: "#409eff",
                                                        },
                                                        attrs: {
                                                          rel: "noopener noreferrer",
                                                          underline: false,
                                                          type: "primary",
                                                          href: _vm.addUrl3W(
                                                            _vm.columnValue(
                                                              scope.row[j],
                                                              item.moduleId
                                                            )
                                                          ),
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.addUrl3W(
                                                              _vm.columnValue(
                                                                scope.row[j],
                                                                item.moduleId
                                                              )
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : item1.field ==
                                                    "webResponseSpeed"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnValue(
                                                            scope.row[j],
                                                            item.moduleId
                                                          ) != 0
                                                            ? _vm.columnValue(
                                                                scope.row[j],
                                                                item.moduleId
                                                              )
                                                              ? _vm.columnValue(
                                                                  scope.row[j],
                                                                  item.moduleId
                                                                ) + "毫秒"
                                                              : "--"
                                                            : "--"
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.columnValue(
                                                            scope.row[j],
                                                            item.moduleId
                                                          ) || "--"
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                      _c("pagination", {
                        attrs: {
                          pageNum: _vm.tablePage(item.moduleId),
                          total: _vm.tableTotal(item.moduleId),
                        },
                        on: {
                          currentChange: function (val) {
                            return _vm.boxCurrentChange(val, i)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }